<article class="testimonial-card">
  @if (imageSrc) {
  <div class="testimonial-card__media">
    <img class="testimonial-card__image"
         [src]="imageSrc"
         [alt]="imageAlt" />
  </div>
  }

  @if (title) {
  <h3 class="testimonial-card__title">{{ title }}</h3>
  }

  <p class="testimonial-card__summary">
    {{ quote }}
  </p>

  <div class="testimonial-card__meta">
    @if (name) {
    <p class="testimonial-card__name">{{ name }}</p>
    }

    @if (role) {
    <p class="testimonial-card__role">{{ role }}</p>
    }
  </div>
</article>
